import React from 'react'
import Practices from '../../../views/corp/practices/Practices'

const corpPracticesRoutes = [
  {
    path: '/corp/practices',
    element: <Practices />
  }
]

export default corpPracticesRoutes